import { json } from '@codemirror/lang-json'
import { EditorView } from '@codemirror/view'
import { Stack } from '@mui/material'
import { EditorState } from '@uiw/react-codemirror'
import CodeMirrorMerge from 'react-codemirror-merge'
import { useAppSelector } from '../../store/Hooks'
interface P {
    comparedValue: string
    currentValue: string
    order?: 'a-b' | 'b-a'
}

const JSONDiff = ({ comparedValue, currentValue, order = 'b-a' }: P) => {
    const mode = useAppSelector(state => state.app.mode)
    const Original = CodeMirrorMerge.Original
    const Modified = CodeMirrorMerge.Modified

    const formattedOriginalValue = JSON.stringify(comparedValue, null, 2)
    const formattedModifiedValue = JSON.stringify(currentValue, null, 2)

    return (
        <Stack sx={{ height: '100%', width: '100%', overflow: 'auto' }}>
            <CodeMirrorMerge highlightChanges={false} theme={mode === 'dark' ? 'dark' : 'light'} orientation={order} style={{ fontSize: '16px' }}>
                <Original value={formattedOriginalValue} extensions={[EditorView.editable.of(false), EditorState.readOnly.of(true), json()]} />
                <Modified value={formattedModifiedValue} extensions={[EditorView.editable.of(false), EditorState.readOnly.of(true), json()]} />
            </CodeMirrorMerge>
        </Stack>
    )
}

export default JSONDiff
